import { isBrowser } from "@/utils/env";

export const ACCESS_TOKEN = "access_token";
const REFRESH_TOKEN = "refresh_token";
const COOKIE_ACCEPTED = "cookie_accepted";
export const COOKIE_CONSENT_CHANGED_EVENT = "cookie_consent_changed";

const token_changed = isBrowser() ? new CustomEvent("token_changed") : null;
const token_expired = isBrowser() ? new CustomEvent("token_expired") : null;

export const getAccessToken = () =>
  localStorage.getItem(ACCESS_TOKEN);

export const hasAccessToken = (): boolean =>
  isBrowser() && !!getAccessToken();

export const getRefreshToken = () =>
  localStorage.getItem(REFRESH_TOKEN);

export const getCookieAccepted = () =>
  localStorage.getItem(COOKIE_ACCEPTED);

export const setAccessToken = (value: string) => {
  localStorage.setItem(ACCESS_TOKEN, value);
  if (token_changed) {
    document.dispatchEvent(token_changed);
  }
};

export const setRefreshToken = (value: string) =>
  localStorage.setItem(REFRESH_TOKEN, value);

export const removeAccessToken = () => {
  localStorage.removeItem(ACCESS_TOKEN);
  if (token_changed) {
    document.dispatchEvent(token_changed);
  }
};

export const removeRefreshToken = () =>
  localStorage.removeItem(REFRESH_TOKEN);

export const setCookieAccepted = (value: any) => {
  localStorage.setItem(COOKIE_ACCEPTED, value);
  if (isBrowser()) {
    document.dispatchEvent(new CustomEvent(COOKIE_CONSENT_CHANGED_EVENT));
  }
};

export const removeCookieAccepted = () => {
  localStorage.removeItem(COOKIE_ACCEPTED);
  if (isBrowser()) {
    document.dispatchEvent(new CustomEvent(COOKIE_CONSENT_CHANGED_EVENT));
  }
};

export const triggerAuthorizationForm = () => {
  if (token_expired) {
    document.dispatchEvent(token_expired);
  }
};
